var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashFolderHoveredIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 73,
    viewBox: "0 0 100 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.26611 12.1624C9.26611 8.84868 11.9524 6.16238 15.2661 6.16238H28.1025C30.5337 6.16238 32.736 7.5968 33.7188 9.82048C34.7015 12.0442 36.9038 13.4786 39.335 13.4786H61.0027H93.8051C97.1188 13.4786 99.8051 16.1649 99.8051 19.4786V67C99.8051 70.3138 97.1188 73 93.8051 73H15.2661C11.9524 73 9.26611 70.3138 9.26611 67V12.1624Z",
    fill: "#9B9BBE",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 4.00005C5 1.79091 6.79086 4.57764e-05 9 4.57764e-05H27.6286C29.2063 4.57764e-05 30.6367 0.92746 31.2804 2.36786L32.7353 5.62295C33.3791 7.06336 34.8094 7.99077 36.3871 7.99077H62.1429H96C98.2091 7.99077 100 9.78163 100 11.9908V69C100 71.2092 98.2091 73 96 73H11C7.68629 73 5 70.3138 5 67V4.00005Z",
    fill: "#3537E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38542 56.4285C6.83431 56.3926 6.41661 55.9168 6.45248 55.3656L9.64974 6.23583C9.6856 5.68472 10.1614 5.26702 10.7126 5.30289L97.1844 10.9303C97.7355 10.9662 98.1532 11.442 98.1174 11.9931L94.9201 61.1229C94.8842 61.674 94.4084 62.0917 93.8573 62.0559L7.38542 56.4285Z",
    fill: "white",
    stroke: "#3537E5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 18C93 15.2386 90.7614 13 88 13H4C2.34315 13 1 14.3432 1 16V69C1 70.6569 2.34315 72 4 72H93.9293C93.3256 70.9485 93 69.7484 93 68.5148V18Z",
    fill: "white",
    stroke: "#3537E5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 55H73.3333H84",
    stroke: "#EB5757",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6666 55C83.6666 54.4477 83.2189 54 82.6666 54C82.1143 54 81.6666 54.4477 81.6666 55H83.6666ZM74.3333 55C74.3333 54.4477 73.8855 54 73.3333 54C72.781 54 72.3333 54.4477 72.3333 55H74.3333ZM74.3333 55C74.3333 55.5523 74.781 56 75.3333 56C75.8855 56 76.3333 55.5523 76.3333 55H74.3333ZM79.6666 55C79.6666 55.5523 80.1143 56 80.6666 56C81.2189 56 81.6666 55.5523 81.6666 55H79.6666ZM81.6666 55V64.3333H83.6666V55H81.6666ZM81.6666 64.3333C81.6666 64.5174 81.5173 64.6667 81.3333 64.6667V66.6667C82.6219 66.6667 83.6666 65.622 83.6666 64.3333H81.6666ZM81.3333 64.6667H74.6666V66.6667H81.3333V64.6667ZM74.6666 64.6667C74.4825 64.6667 74.3333 64.5174 74.3333 64.3333H72.3333C72.3333 65.622 73.3779 66.6667 74.6666 66.6667V64.6667ZM74.3333 64.3333V55H72.3333V64.3333H74.3333ZM76.3333 55V53.6667H74.3333V55H76.3333ZM76.3333 53.6667C76.3333 53.4826 76.4825 53.3333 76.6666 53.3333V51.3333C75.3779 51.3333 74.3333 52.378 74.3333 53.6667H76.3333ZM76.6666 53.3333H79.3333V51.3333H76.6666V53.3333ZM79.3333 53.3333C79.5173 53.3333 79.6666 53.4826 79.6666 53.6667H81.6666C81.6666 52.378 80.6219 51.3333 79.3333 51.3333V53.3333ZM79.6666 53.6667V55H81.6666V53.6667H79.6666Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6667 58.3333V62.3333",
    stroke: "#EB5757",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3333 58.3333V62.3333",
    stroke: "#EB5757",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: -10.7339,
    y: -13.8376,
    width: 130.539,
    height: 106.838,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 73,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashFolderHoveredIcon);
export default __webpack_public_path__ + "static/media/trash-folder-hovered-icon.c69cc86e3c5efe596b3abf4011753cdf.svg";
export { ForwardRef as ReactComponent };